import Vue from 'vue';
import { $lang } from 'laravel-vue-lang';
import dayjs from './dayjs';

let locale;

try {
  locale = $lang().getLocale();

  if (locale === 'pt_BR') {
    locale = 'pt-BR';
  }
} catch (e) {
  locale = 'pt-BR';
}

Vue.filter('truncate', (value = null, length = 20) => (
  value === null || value.length <= length ? value : `${value.substring(0, length - 3).trim()}...`
));

Vue.filter('pluralizeBr', (number, str) => (number > 1 ? `${str}s` : str));

Vue.filter('first', (str = '') => str.charAt(0));

Vue.filter('firstword', (str) => str.split(' ')[0]);

Vue.filter('date', (date, format = 'LD') => dayjs(date).format(format));

Vue.filter('datetime', (date, format = 'LDT') => dayjs(date).format(format));

Vue.filter('ago', (time) => dayjs(time).fromNow());

Vue.filter('nl2br', (str = '') => str.replace(/(?:\r\n|\r|\n)/g, '<br>'));

Vue.filter('capitalize', (str = '') => str.charAt(0).toUpperCase() + str.slice(1));

// eslint-disable-next-line prefer-arrow-callback
Vue.filter('number', function (value, decimal = 2) {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(value || 0);
});

// eslint-disable-next-line prefer-arrow-callback
Vue.filter('percent', function (value, decimal = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(value || 0);
});

// eslint-disable-next-line prefer-arrow-callback
Vue.filter('currency', function (value, decimal = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
    currency: locale === 'pt-BR' ? 'BRL' : 'USD',
  }).format(value || 0);
});

Vue.filter('uppercase', (str = '') => str.toUpperCase());

Vue.filter('lowercase', (str = '') => str.toLowerCase());

